import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { setDeepValue as t } from "./object.js";

var o = /*#__PURE__*/function () {
  function o(_o) {
    var _this = this;

    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ignoreUnknown: !1
    };

    _classCallCheck(this, o);

    this.jsonToAPI = _o, this.options = s, this.apiValues = [], this.jsonValues = [], this.apiToJSON = this.invertMap(_o), this.apiValues = this.getKeysSorted(this.apiToJSON), this.jsonValues = this.getKeysSorted(this.jsonToAPI), this.read = function (t) {
      return _this.fromJSON(t);
    }, this.write = function (_o2, s, i) {
      var n = _this.toJSON(_o2);

      void 0 !== n && t(i, n, s);
    }, this.write.isJSONMapWriter = !0;
  }

  _createClass(o, [{
    key: "toJSON",
    value: function toJSON(t) {
      return this.apiToJSON.hasOwnProperty(t) ? this.apiToJSON[t] : this.options.ignoreUnknown ? void 0 : t;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return this.jsonToAPI.hasOwnProperty(t) ? this.jsonToAPI[t] : this.options.ignoreUnknown ? void 0 : t;
    }
  }, {
    key: "invertMap",
    value: function invertMap(t) {
      var _o3 = {};

      for (var _s in t) {
        _o3[t[_s]] = _s;
      }

      return _o3;
    }
  }, {
    key: "getKeysSorted",
    value: function getKeysSorted(t) {
      var _o4 = [];

      for (var _s2 in t) {
        _o4.push(_s2);
      }

      return _o4.sort(), _o4;
    }
  }]);

  return o;
}();

function s() {
  return function (t) {
    return new o(t, {
      ignoreUnknown: !0
    });
  };
}

export { o as JSONMap, o as default, s as strict };